<template>
  <nav>
    <div class="nav-upper">
      <div class="user-info-wrap">
        <div class="smile">
          <img src="@/assets/img/smile.svg" />
        </div>
        <div class="contents">
          <div class="mId">{{ siteInfo ? siteInfo.adminId : '' }}</div>
          <div class="mini">관리자</div>
        </div>
        <button type="button" @click="signOut" class="logout-link">로그아웃</button>
      </div>
    </div>
    <ul class="menu-wrap nav-bottom">
      <li v-for="menu in menuList" :key="menu.name">
        <ul class="content-wrap" :class="{ active: menu.isActive }">
          <li class="menu-title" @click="menu.isActive = !menu.isActive">
            <div class="text-wrap">
              <img :src="require(`@/assets/img/${menu.icon}`)" />
              <span class="text">{{ menu.text }}</span>
            </div>
            <i class="fas fa-chevron-right" />
          </li>
          <li class="menu-contents">
            <ul>
              <template v-for="child in menu.children">
                <li :key="child.path" v-if="child.meta.menuMember">
                  <a v-if="!child.children" :href="child.path" class="supMenu" :class="{ active: child.meta.isActive }">
                    <span v-if="child.meta.text">{{ child.meta.text }}</span>
                    <span v-else>{{ $t(child.meta.transCode) }}</span>
                  </a>
                  <!-- <router-link v-if="!child.children" :to="child.path" class="supMenu" >
                    <span v-if="child.meta.text">{{child.meta.text}}</span>
                    <span v-else>{{$t(child.meta.transCode)}}</span>
                  </router-link> -->
                  <ul class="subMenu-container" v-else>
                    <li class="supMenu subMenu-title" @click="child.meta.isActive = !child.meta.isActive" :class="[{ active: child.meta.isActive }]">{{ child.meta.text }}</li>
                    <li>
                      <ul class="subMenu-wrap" :class="{ active: child.meta.isActive }">
                        <li v-for="subMenu in child.children" :key="subMenu.path">
                          <a :href="subMenu.path" class="subMenu" :class="{ active: subMenu.meta.isActive }">{{ subMenu.meta.text }}</a>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
              </template>
            </ul>
          </li>
        </ul>
      </li>
    </ul>
  </nav>
</template>

<script>
import { removeAuthData, getSiteData } from "@/libs/auth-helper";
// import { partnerDetail, creditChargeApply } from "@/api/member";
import { mapMutations } from "vuex";
import {partnerDetail} from "@/api/partner";

export default {
  name: "Nav",
  data() {
    return {
      items: [],
      loginPath: "/login",
      siteInfo: {},
      menuList: [],
      currentMenu: "",
      creditApplyData: {
        creditType: "1",
        creditAmt: "0"
      },
      currentSubMenu: ""
    };
  },
  created() {
    this.setMenuList();
    this.getCurrentMenu();
    this.siteInfo = this.getSiteName();
    // this.getUpperPartner();
    if (!this.siteInfo) {
      removeAuthData()
    }
  },
  methods: {
    getSiteName() {
      const siteInfoCookie = getSiteData();
      if (siteInfoCookie) {
        const siteInfo = JSON.parse(siteInfoCookie);
        return siteInfo;
      }
    },
    async getUpperPartner() {
      const siteId = this.siteInfo.adminId;
      const reqDetail = {
        memId: siteId
      };
      const loginPartnerDetail = await partnerDetail(reqDetail);
      // console.log(loginPartnerDetail);
      // this.siteInfo.recommenderId = loginPartnerDetail.data.member.recommenderId;
    },
    async creditApply() {
      const creditAmt = prompt("요청하실 크레딧 금액을 적어주세요.", 0);

      if (creditAmt === null || creditAmt === undefined) {
        return;
      } else if (creditAmt <= 0) {
        alert("최소 충전 크레딧은 0 이상이어야 합니다.");
        return;
      } else if (isNaN(creditAmt)) {
        alert("숫자만 작성해주세요.");
        return;
      }

      this.creditApplyData.creditAmt = creditAmt;
      const trigger = confirm(`${creditAmt}크레딧을 요청하시겠습니까?`);
      if (trigger) {
        const result = await creditChargeApply(this.creditApplyData);
        // console.log(result);
        if (result.resultCode === "0") {
          alert(`크레딧 신청완료`);
        } else {
          alert("크레딧 요청 실패, 다시 시도해주세요.");
        }
      }
      this.creditApplyData.creditAmt = 0;
    },
    ...mapMutations(["setErrorData", "clearAllSiteData"]),
    signOut() {
      this.clearAllSiteData();
      removeAuthData();
      this.$router.replace({ name: "login" });
    },
    setMenuList() {
      const items = this.$router.getRoutes();

      // console.log(this.menuList)

      // console.log(this.currentMenu);
      // console.log(this.currentMenu.child.text)

      for (const item of items) {
        const routeName = item.name;
        if (routeName === "member") {
          for (const mItem of item.children) {
            this.menuList.push({
              name: mItem.name,
              path: mItem.path,
              text: mItem.meta.text,
              icon: mItem.meta.icon,
              isActive: mItem.meta.isActive,
              children: mItem.children
            });
          }
        }
      }
    },
    getCurrentMenu() {
      this.currentMenu = this.$route.matched[1];
      this.currentSubMenu = this.$route.matched[2];
      this.currentGrandSubMenu = this.$route.matched[3];

      for (const menu of this.menuList) {
        if (menu.name === this.currentMenu.name) {
          // console.log(menu)
          menu.isActive = true;
          for (const subMenu of menu.children) {
            if (subMenu.name === this.currentSubMenu.name) {
              subMenu.meta.isActive = true;
            } else {
              subMenu.meta.isActive = false;
            }
            if (this.currentGrandSubMenu) {
              if (subMenu.children) {
                for (const grandChild of subMenu.children) {
                  if (grandChild.name === this.currentGrandSubMenu.name) {
                    grandChild.meta.isActive = true;
                  } else {
                    grandChild.meta.isActive = false;
                  }
                }
              }
            }
          }
        } else {
          menu.isActive = false;
        }
      }
    }
  },
  watch: {
    $route: {
      handler() {
        // console.log('pageTitle : ', this.$route)
        if (this.$route.fullPath !== "/login") {
          this.getCurrentMenu();
        }
      }
    }
  }
};
</script>

<style scoped>
nav {
  width: 240px;
  min-height: calc(100vh - 50px);
  padding-bottom: 40px;
  filter: drop-shadow(0px 10px 6px rgba(0, 0, 0, 0.16));
  background-color: #ffffff;
}
.nav-upper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  border-bottom: 1px solid #e6e6f6;
  margin-bottom: 5px;
}
.nav-bottom {
  border-top: 1px solid #e6e6f6;
}
.user-info-wrap {
  box-sizing: border-box;
  margin-bottom: 10px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.user-info-wrap:last-child {
  margin: 0;
}
.user-info-wrap .title {
  font-size: 0.8em;
  color: #000;
  font-weight: 700;
  margin-bottom: 5px;
}
.user-info-wrap .contents {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  margin-bottom:20px;
}
.mId {
  font-weight: 800;
  color: #000;
  font-size: 16px;
  max-width: 125px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.mId + .mini{
  font-size: 12px;
color: #0c4695;
font-weight: 500;
}
.logout-link {
  border-radius: 3px;
  font-size: 14px;
  cursor: pointer;
  width: 180px;
  height: 23px;
  color: #8f8faa;
  border-radius: 3px;
  font-weight: 500;
  background: #fff;
  border: 1px solid #e6e6f6;
}
.logout-link:hover {
  background: #126ae2;
  color: #fff;
}
.img-profile {
  width: 38px;
  border-radius: 100%;
  margin-right: 8px;
}
.wopen-note {
  color: #fff;
  font-weight: 800;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  font-size: 0.8em;
  cursor: pointer;
  user-select: none;
}
.wopen-note img {
  width: 26px;
  margin-bottom: 6px;
}

nav .content-wrap {
  overflow: hidden;
}
nav .content-wrap.active {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  padding-bottom: 10px;
}
nav .content-wrap:not(.active):hover {
}
.menu-title {
  color: #000;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 0.906em;
  cursor: pointer;
  padding: 10px 14px 10px;
}
nav .content-wrap.active > .menu-title {
  font-weight: 700;
  margin-bottom: 4px;
  background-color: #e6e6f6;
}
.text-wrap .text {
  font-size: 16px;
  color: #27273f;
  font-weight: 500;
  margin-left: 8px;
}
.fa-chevron-right {
  font-size: 13px;
}
.menu-contents {
  max-height: 0;
  overflow: hidden;
  font-size: 0.78em;
}
nav .content-wrap.active > .menu-contents {
  max-height: 1000px;
  /* overflow: unset; */
  transition: 0.5s;
}

.menu-contents li {
  position: relative;
}
.menu-contents .supMenu {
  display: flex;
  height: 30px;
  align-items: center;
  padding-left: 48px;
  font-size: 14px;
  color: #8f8faa;
  font-weight: 500;
  width: 100%;
  box-sizing: border-box;
  cursor: pointer;
}
.menu-contents .supMenu:hover {
  /* background: #18698b; */
  /* color: #fff; */
  color:#27273f;
  font-weight: 800;
}
.menu-contents .subMenu-wrap {
  max-height: 0;
  overflow: hidden;
  /* background-color: #b77c66; */
}
.menu-contents .subMenu {
  display: flex;
  height: 30px;
  align-items: center;
  font-weight: 300;
  color: #18698b;
  width: 100%;
  box-sizing: border-box;
  padding-left: 60px;
}
.menu-contents .subMenu::before {
  content: "";
  display: block;
  width: 5px;
  height: 1px;
  margin-right: 10px;
  background-color: #18698b;
}
.menu-contents .subMenu:hover::before {
  background-color: #fff !important;
}
.menu-contents .subMenu-wrap.active {
  max-height: 500px;
}
.menu-contents .subMenu-container {
  flex-direction: column;
  align-items: flex-start;
}
.menu-contents a.router-link-exact-active,
.menu-contents a.router-link-active,
.menu-contents .supMenu.active,
.menu-contents .subMenu-title.active {
  /* background: #18698b; */
  color:  #27273f;
  font-weight: 700;
}
.menu-wrap a:hover {
  /* background: #18698b; */
  color:  #27273f;
}
.menu-contents a.router-link-exact-active:hover,
.menu-contents a.router-link-active:hover,
.menu-contents .subMenu-title.active:hover {
  /* background: #18698b; */
}
.menu-contents a.subMenu.router-link-exact-active::before,
.menu-contents a.subMenu.router-link-active::before,
.menu-contents a.subMenu.active::before {
  /* background: #216987; */
}
.menu-contents a.subMenu.router-link-exact-active,
.menu-contents a.subMenu.router-link-active,
.menu-contents a.subMenu.active {
  /* color: #216987; */
  font-weight: 800;
}

.menu-contents a.subMenu.router-link-exact-active:hover,
.menu-contents a.subMenu.router-link-active:hover,
.menu-contents .subMenu.active:hover {
  color: #fff;
}
.btn-credit-apply {
  font-size: 0.75em;
  border: 1px solid #18698b;
  box-sizing: border-box;
  background: #18698b;
  color: #fff;
  font-weight: 700;
  padding: 3px 4px;
  border-radius: 3px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  cursor: pointer;
}
.btn-credit-apply:hover {
  color: #18698b;
  background: #fff;
}
.supMenu.done:before {
  content: "";
  display: block;
  width: 10px;
  height: 10px;
  border-radius: 100%;
  background-color: green;
  position: absolute;
  top: 50%;
  left: 10px;
  transform: translateY(-50%);
}
.smile {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 57px;
  height: 57px;
  border-radius: 10px;
  background-color: #ffffff;
  border: 1px solid #8f8faa;
}
</style>
